var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatients1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-51",
    d: "M90.75,268.8C2.8,319.58,2.8,401.9,90.75,452.68s230.55,50.78,318.5,0,87.95-133.1,0-183.88S178.7,218,90.75,268.8Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-51",
    d: "M210.82,389.57,306.9,334.1a10.89,10.89,0,0,1,9.82,0l114,65.84c2.7,1.56,2.71,4.12,0,5.69l-13.09,7.62,12.42,7.17c2.7,1.56,2.7,4.12,0,5.69l-58.95,34.32a10.84,10.84,0,0,1-9.81,0l-12.42-7.17-13.81,8a10.81,10.81,0,0,1-9.8,0l-114.5-66.1C208.12,393.68,208.12,391.13,210.82,389.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-51",
    d: "M114.7,361.12c15.37,9,15.37,23.53,0,32.51s-40.31,9-55.69,0-15.37-23.53,0-32.51S99.32,352.14,114.7,361.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-51",
    d: "M157.16,347.19c-28.52,16.46-28.52,43.16,0,59.63s74.76,16.46,103.28,0,28.52-43.16,0-59.63S185.68,330.72,157.16,347.19Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-51"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "455.31 248.99 452.56 250.64 358.86 196.54 361.61 194.9 455.31 248.99",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.61 194.9 452.56 247.4 452.56 95.24 361.61 42.76 361.61 194.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.66,199.54l104.1,60.1V92.24l-104.1-60.1Zm5.2-158.39,93.7,54.09v155.4l-93.7-54.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.86 196.54 361.61 194.9 361.61 42.76 358.86 41.15 358.86 196.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.56 203.09 452.56 206.32 358.86 152.22 361.61 150.58 452.56 203.09",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.56 130.34 452.56 133.58 358.86 79.48 361.61 77.84 452.56 130.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.66 32.14 356.46 30.54 460.55 90.64 457.76 92.24 353.66 32.14",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.55 90.64 457.76 92.24 457.76 259.64 460.55 258.04 460.55 90.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.48 72.11 409.68 70.49 409.68 225.89 412.48 224.29 412.48 72.11",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "404.49 67.5 409.68 70.49 409.68 225.89 404.49 222.88 404.49 67.5",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.66 76.48 353.66 82.47 457.76 142.57 457.76 136.58 353.66 76.48",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.66 149.21 353.66 155.2 457.76 215.3 457.76 209.31 353.66 149.21",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.68 108.83 412.48 107.21 452.56 130.34 452.56 133.58 409.68 108.83",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.68 181.53 412.48 179.92 452.56 203.05 452.56 206.29 409.68 181.53",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.55,379.63c13.2-13.63,21-51.79,8.08-62.6H54.08c-12.88,10.8-5.13,49,8.07,62.58.12.13.25.25.36.38l.46.45c.37.36.77.72,1.19,1.07l.32.25c.32.26.64.52,1,.76q.86.62,1.71,1.11c10.87,6.34,28.48,6.34,39.35,0h0c.58-.33,1.15-.71,1.72-1.11.33-.23.62-.47.93-.71l.39-.31c.41-.34.79-.69,1.15-1l.52-.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.77,312.67c-15,8.74-15,22.89,0,31.62s39.21,8.74,54.16,0,15-22.88,0-31.62S74.73,303.94,59.77,312.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,316.87c-11,6.42-11,16.81,0,23.22s28.79,6.42,39.77,0,11-16.81,0-23.23S78,310.46,67,316.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.74,327.89c-11-6.41-28.79-6.41-39.77,0a18.49,18.49,0,0,0-6.58,6.1,18.32,18.32,0,0,0,6.58,6.1c11,6.42,28.79,6.42,39.77,0a18.32,18.32,0,0,0,6.58-6.1A18.49,18.49,0,0,0,106.74,327.89Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68,239.46l17.63,18.2-17.88-11.3a53.07,53.07,0,0,0,.93,18.48s8.64,6.82,13.44,12.45l-13.83-7.68s-2.27,9.49-.2,24.69c.55,4,3.9,11.88,5.91,17.73a63.25,63.25,0,0,0,3.27,7.87c.07.17.16.32.24.49q5.39-2.2,11.13-4.19c3-4.62,7.66-16.41,10.08-26.24,9.22-37.66-16.79-63.35-39-73.75C59.69,216.21,66.35,227.27,68,239.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.27,243.22c3.49,4.57,5.14,10.2,6.24,15.75a78.09,78.09,0,0,1,1.32,17,72.29,72.29,0,0,1-8.52,32.63h0a.56.56,0,1,0,1,.54h0A73.05,73.05,0,0,0,92.39,276a78.79,78.79,0,0,0-1.6-17.06C89.59,253.36,87.83,247.73,84.27,243.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.69,253.19l0,0c-.53.63-9.15,11-21.94,31.06l-21.4,3.51,15.8,2.71L121.69,304l-21.06,4.43L117.1,311s-4.52,16.07-16.27,22.8c-6.49,3.72-9.31,3.82-11.62,2.45-2.83-1.68-4.19-6.28-5.35-13.15s1.18-20.76,7.62-34.27a42.13,42.13,0,0,1,6.71-9.93C113.71,261.5,143.13,253,157.69,253.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.32,260.27c-11.06,4.9-21.51,11.6-29.71,20.67a58.69,58.69,0,0,0-10.15,15.18,55.35,55.35,0,0,0-4.59,17.61.05.05,0,0,0,0,.06.08.08,0,0,0,.07-.05,70.86,70.86,0,0,1,5.55-17.12,65.8,65.8,0,0,1,9.78-15.05c7.93-9.09,18.15-16,29.05-21.19a.05.05,0,0,0,0-.08A.05.05,0,0,0,135.32,260.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.87,262.39h0a49.26,49.26,0,0,1,5.94-.27,95,95,0,0,1,23.11,3.45c2.8.76,5.61,1.66,8.39,2.69q2.09.76,4.14,1.65A65.73,65.73,0,0,1,72,281.44a41.27,41.27,0,0,1,6.72,7.83c.25.38.51.74.74,1.12h0c.6,1,1.14,2,1.66,2.92,6,10.84,7.16,18.64,7.63,27.36.37,6.77-1.22,14.69-2.42,16.07a2.84,2.84,0,0,1-.55.49c-1.81,1.4-4.93,1-10.94-1.72-12-5.36-18-21.17-18-21.17l15.67-4.15L51.69,308l-9.48-12.2,15-4.16-21-1.31c-14.34-18.19-23.7-27.34-24.27-27.9l0,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.81,262.12a95,95,0,0,1,23.11,3.45c2.8.76,5.61,1.66,8.39,2.69q2.09.76,4.14,1.65A65.73,65.73,0,0,1,72,281.44a41.27,41.27,0,0,1,6.72,7.83c.25.38.51.74.74,1.12h0c.6,1,1.14,2,1.66,2.92,6,10.84,7.16,18.64,7.63,27.36.37,6.77-1.22,14.69-2.42,16.07a2.84,2.84,0,0,1-.55.49,3.53,3.53,0,0,1-1.22.58C85,327.23,77.46,301.19,68.68,291c-9.13-10.61-29.84-25.31-56.77-28.59l0,0A50.47,50.47,0,0,1,17.81,262.12Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.61,337.82a90.14,90.14,0,0,0-3.6-23,75,75,0,0,0-9.66-21.23c-4.54-6.46-10.67-11.53-17.1-15.92a87.19,87.19,0,0,0-21-10.13.07.07,0,0,0-.08,0,.06.06,0,0,0,0,.08,114.84,114.84,0,0,1,20.32,11.09,83.2,83.2,0,0,1,9.12,7.07,50.6,50.6,0,0,1,7.85,8.38A73.76,73.76,0,0,1,80.38,315a89.62,89.62,0,0,1,4.1,22.8.07.07,0,0,0,.07.06A.06.06,0,0,0,84.61,337.82Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--sign--inject-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.22,40.33l-96,55.36a7.84,7.84,0,0,0-3.55,6.14V138a7.73,7.73,0,0,0,3.57,6.1l.26.16a7.94,7.94,0,0,0,7.11,0l96-55.36a7.83,7.83,0,0,0,3.54-6.13V46.55a7.74,7.74,0,0,0-3.56-6.1l-.27-.16A7.94,7.94,0,0,0,132.22,40.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.64,144.23a8.07,8.07,0,0,1-7.11,0l-.26-.16A7.71,7.71,0,0,1,32.7,138V101.83a7.27,7.27,0,0,1,1.13-3.62l7.31,4.31a7,7,0,0,0-1,3.48v36.18C40.1,144.25,41.55,145.44,43.64,144.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.62,44.51l-96,55.36A7.81,7.81,0,0,0,40.1,106v36.19c0,2.26,1.58,3.17,3.54,2l96-55.36a7.83,7.83,0,0,0,3.54-6.13V46.55C143.16,44.29,141.57,43.38,139.62,44.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.2,45c.83,0,1,1,1,1.53V82.74a6.85,6.85,0,0,1-3,5.27l-96,55.36a2.26,2.26,0,0,1-1.08.35c-.84,0-1-1-1-1.53V106a6.84,6.84,0,0,1,3-5.27l96-55.36A2.23,2.23,0,0,1,141.2,45m0-1a3.17,3.17,0,0,0-1.58.49l-96,55.36A7.81,7.81,0,0,0,40.1,106v36.19c0,1.6.8,2.53,2,2.53a3.22,3.22,0,0,0,1.58-.49l96-55.36a7.83,7.83,0,0,0,3.54-6.13V46.55c0-1.6-.8-2.53-2-2.53Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.53,103.72a.27.27,0,0,1,.33,0,.58.58,0,0,1,.14.43v17a1.34,1.34,0,0,1-.14.58.8.8,0,0,1-.33.4l-2.24,1.3a.24.24,0,0,1-.32,0,.53.53,0,0,1-.14-.42v-6.46l-3.8,2.2v6.45a1.34,1.34,0,0,1-.14.58.84.84,0,0,1-.32.4l-2.25,1.3a.25.25,0,0,1-.32,0,.58.58,0,0,1-.14-.44V110a1.34,1.34,0,0,1,.14-.58.84.84,0,0,1,.32-.4l2.25-1.3a.24.24,0,0,1,.32,0,.57.57,0,0,1,.14.42v6.35l3.8-2.19V106a1.27,1.27,0,0,1,.14-.58.86.86,0,0,1,.32-.39Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,109.18a14.44,14.44,0,0,1,.42-3,13.18,13.18,0,0,1,1-2.86,11.64,11.64,0,0,1,1.65-2.48A8.47,8.47,0,0,1,68.34,99a4.56,4.56,0,0,1,2.23-.72,2.53,2.53,0,0,1,1.65.58,3.57,3.57,0,0,1,1,1.66,8.7,8.7,0,0,1,.42,2.54c0,.74,0,1.53,0,2.35s0,1.61,0,2.34a14.26,14.26,0,0,1-.42,3,13.43,13.43,0,0,1-1,2.89,11.64,11.64,0,0,1-1.65,2.48,9.08,9.08,0,0,1-2.23,1.84,4.71,4.71,0,0,1-2.23.73,2.38,2.38,0,0,1-1.65-.58,3.71,3.71,0,0,1-1-1.67,8.7,8.7,0,0,1-.42-2.54c0-.71,0-1.48,0-2.3S63,110,63,109.18Zm7.51.22c0-.33,0-.68,0-1.08s0-.79,0-1.19,0-.79,0-1.16,0-.71,0-1a4.44,4.44,0,0,0-.18-1.11,1.57,1.57,0,0,0-.41-.72,1,1,0,0,0-.66-.27,1.83,1.83,0,0,0-.92.3,3.61,3.61,0,0,0-.93.77,4.38,4.38,0,0,0-.65,1,5.78,5.78,0,0,0-.42,1.19,8.22,8.22,0,0,0-.17,1.32c0,.31,0,.66,0,1s0,.77,0,1.18,0,.8,0,1.18,0,.72,0,1a2.85,2.85,0,0,0,.59,1.84c.34.38.87.37,1.58,0a3.69,3.69,0,0,0,1.57-1.78A7.06,7.06,0,0,0,70.51,109.4Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.13,92.14a4.53,4.53,0,0,1,2-.67,2.8,2.8,0,0,1,1.58.34,2.64,2.64,0,0,1,1,1.08,3.36,3.36,0,0,1,.4,1.54,1.15,1.15,0,0,1-.11.47.79.79,0,0,1-.25.32l-2.24,1.29a.73.73,0,0,1-.39.12.71.71,0,0,1-.3-.15l-.16-.17a.82.82,0,0,0-.32-.19,1,1,0,0,0-.51-.05,2,2,0,0,0-.76.29,4.93,4.93,0,0,0-.62.43,3.21,3.21,0,0,0-.53.51,2.52,2.52,0,0,0-.38.63,1.84,1.84,0,0,0-.14.74.83.83,0,0,0,.16.57.75.75,0,0,0,.55.17,4.33,4.33,0,0,0,1-.16l1.57-.4a5.5,5.5,0,0,1,1.64-.22,2,2,0,0,1,1.18.45,2.49,2.49,0,0,1,.7,1.17,7.43,7.43,0,0,1,.23,2,8.94,8.94,0,0,1-.39,2.62A10.79,10.79,0,0,1,84,107.34a10.68,10.68,0,0,1-1.68,2.11,10.22,10.22,0,0,1-2.11,1.62,5.12,5.12,0,0,1-2.12.75,3,3,0,0,1-1.66-.3,2.66,2.66,0,0,1-1.08-1.12,3.85,3.85,0,0,1-.41-1.74,1.05,1.05,0,0,1,.11-.48.62.62,0,0,1,.25-.31l2.24-1.3a.68.68,0,0,1,.38-.12.54.54,0,0,1,.27.12l.2.22a1.34,1.34,0,0,0,.37.28,1.18,1.18,0,0,0,.59.1,2.14,2.14,0,0,0,.86-.32,6.33,6.33,0,0,0,1.51-1.18,2,2,0,0,0,.61-1.44.57.57,0,0,0-.22-.53,1.09,1.09,0,0,0-.67-.1,5.72,5.72,0,0,0-1.14.22c-.46.13-1,.26-1.63.41a2.47,2.47,0,0,1-2.58-.44,4.74,4.74,0,0,1-.81-3.16,9,9,0,0,1,.33-2.35,11.34,11.34,0,0,1,1-2.38,11,11,0,0,1,1.53-2.14A8.62,8.62,0,0,1,80.13,92.14Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.58,85.22a5.6,5.6,0,0,1,2-.75,2,2,0,0,1,1.49.3A2.7,2.7,0,0,1,97,86.15a7.92,7.92,0,0,1,.33,2.5A12.23,12.23,0,0,1,97,91.56,10.56,10.56,0,0,1,96,94a9.34,9.34,0,0,1-1.49,2,8.9,8.9,0,0,1-2,1.53l-2.19,1.27v5.37a1.34,1.34,0,0,1-.14.58.84.84,0,0,1-.32.4l-2.25,1.3a.24.24,0,0,1-.32,0,.57.57,0,0,1-.14-.42V89a1.34,1.34,0,0,1,.14-.58.84.84,0,0,1,.32-.4Zm-2.19,9.51,2.1-1.21a3.36,3.36,0,0,0,1.66-3c0-.74-.15-1.18-.47-1.32a1.28,1.28,0,0,0-1.19.2l-2.1,1.21Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.43,99.72a.25.25,0,0,1-.33,0,.56.56,0,0,1-.14-.42v-17a1.34,1.34,0,0,1,.14-.58.8.8,0,0,1,.33-.4l2.24-1.3a.24.24,0,0,1,.32,0,.54.54,0,0,1,.14.42v17A1.34,1.34,0,0,1,102,98a.84.84,0,0,1-.32.4Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33,73.24a.25.25,0,0,1,.32,0,.58.58,0,0,1,.14.43v2.79a1.37,1.37,0,0,1-.14.58.9.9,0,0,1-.32.4l-3,1.74V92.72a1.36,1.36,0,0,1-.13.58.91.91,0,0,1-.33.4L107.61,95a.25.25,0,0,1-.33,0,.57.57,0,0,1-.13-.42V81l-3,1.74a.24.24,0,0,1-.32,0,.56.56,0,0,1-.14-.42V79.53a1.34,1.34,0,0,1,.14-.58.9.9,0,0,1,.32-.4Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.46,69.12c.23-.13.41-.13.53,0a.91.91,0,0,1,.24.44L125,84a1.48,1.48,0,0,1,.06.36,1,1,0,0,1-.11.47.7.7,0,0,1-.26.33l-2.16,1.24c-.23.14-.39.16-.49.06a.67.67,0,0,1-.18-.33l-.48-1.91-4.55,2.63-.48,2.46a1.71,1.71,0,0,1-.18.54,1.14,1.14,0,0,1-.49.51l-2.15,1.24a.2.2,0,0,1-.27,0,.46.46,0,0,1-.11-.34,2.08,2.08,0,0,1,.07-.44L116.92,72a4,4,0,0,1,.25-.73,1.25,1.25,0,0,1,.52-.59Zm-2.77,13.12,2.77-1.6-1.38-5.53Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.81,75.07a.25.25,0,0,1,.32,0,.54.54,0,0,1,.14.43v2.79a1.24,1.24,0,0,1-.14.58.9.9,0,0,1-.32.4l-7.93,4.57a.23.23,0,0,1-.32,0,.57.57,0,0,1-.14-.42v-17a1.41,1.41,0,0,1,.14-.58,1,1,0,0,1,.32-.4l2.25-1.29a.25.25,0,0,1,.32,0,.57.57,0,0,1,.14.42V78.09Z",
    style: {
      fill: "#845EC2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters--inject-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--wheel-chair--inject-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.17,259.36l-2.57-1.63c-6.34-4-12.41-6-17.86-6.33h-.48a24.17,24.17,0,0,0-2.83.06,31,31,0,0,0-21.63,11l-.31.35a7.93,7.93,0,0,0-.53.65l-.34.45c-.15.18-.29.37-.42.55-.25.37-.5.73-.74,1.11l-.25.41c-.12.18-.22.37-.33.56l0,.07a30.86,30.86,0,0,0-4.3,14.63l-.05,1.24c0,.56-.07,1.14-.1,1.72l-.12,3c-1,26.37,16.23,59.16,38.55,73.23l2.58,1.63c6.34,4,12.4,6,17.86,6.33h.16l.22,0c.36,0,.71,0,1.07,0h.34l.92,0,.46,0,.24,0a31,31,0,0,0,22.13-11.7c.23-.28.45-.57.67-.86l.08-.11c.25-.34.5-.69.73-1.05a30.8,30.8,0,0,0,5.21-16l.11-3,.12-3.05C378.75,306.22,361.5,273.43,339.17,259.36ZM326.46,352.3c-18.84-11.89-33.42-39.57-32.55-61.83s16.85-30.68,35.7-18.79S363,311.24,362.16,333.5,345.3,364.18,326.46,352.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.25,263.54l-2.58-1.63c-11-7-21.25-8-28.88-4.16-.2.1-.39.2-.59.32l-.14.08-.69.4c-.22.14-.45.28-.67.44a12.44,12.44,0,0,0-1.29.94l-.61.51c-.41.35-.81.72-1.19,1.11q-.3.3-.57.6l-.55.62a7.93,7.93,0,0,0-.53.65l-.34.45c-.15.18-.29.37-.42.55-.25.37-.5.73-.74,1.11l-.25.41c-.12.18-.22.37-.33.56l-.31.57c-.37.68-.72,1.39-1,2.14-.18.39-.35.79-.5,1.19,0,0,0,0,0,.05-.28.73-.54,1.5-.78,2.28-.14.43-.26.85-.38,1.3s-.26,1-.37,1.51c-.05.24-.11.49-.16.73-.09.42-.16.85-.24,1.27s-.16.95-.23,1.45l0,.24c-.06.42-.11.83-.16,1.26,0,.17,0,.35-.05.52,0,.46-.09.94-.12,1.43s-.07,1.14-.1,1.72l-.12,3c-1,26.37,16.23,59.16,38.55,73.23l2.58,1.63c6.49,4.09,12.68,6.14,18.24,6.36.36,0,.71,0,1.07,0h.34l.92,0,.46,0c.31,0,.61-.05.91-.09l.81-.11.78-.13c.5-.1,1-.21,1.47-.35l.61-.17a6.37,6.37,0,0,0,.66-.21l.57-.21a11,11,0,0,0,1.19-.49,5.15,5.15,0,0,0,.59-.27l.15-.08a1.27,1.27,0,0,0,.23-.12l.37-.18c7.51-4.1,12.4-13.12,12.91-26.16l.11-3.05C370.82,310.39,353.56,277.61,331.25,263.54Zm-4.79,88.76c-18.84-11.89-33.42-39.57-32.55-61.83s16.85-30.68,35.7-18.79S363,311.24,362.16,333.5,345.3,364.18,326.46,352.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65,347.6c-5.78,6.35-15.38,6.92-26,.22-16.76-10.56-29.71-35.17-28.94-55,.35-8.84,3.38-15.23,8.12-18.65-3.35,3.67-5.44,9.26-5.72,16.5-.77,19.79,12.18,44.39,28.93,55C338.29,351.51,346.78,351.84,352.65,347.6Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65,347.6c-5.78,6.35-15.38,6.92-26,.22-16.76-10.56-29.71-35.17-28.94-55,.35-8.84,3.38-15.23,8.12-18.65-3.35,3.67-5.44,9.26-5.72,16.5-.77,19.79,12.18,44.39,28.93,55C338.29,351.51,346.78,351.84,352.65,347.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.61,271.68c-18.85-11.88-34.83-3.47-35.7,18.79s13.7,49.94,32.55,61.83,34.82,3.47,35.69-18.8S348.45,283.56,329.61,271.68Zm-3,76.14c-16.75-10.57-29.7-35.17-28.93-55s15-27.27,31.73-16.7,29.71,35.16,28.93,54.95S343.38,358.38,326.63,347.82Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.7,321.23c-.06-.35-.12-.71-.19-1.06l-26.74-8.3-.58-.93,20.31-10.69c-.14-.28-.3-.56-.45-.84L329.74,310.1l-.43-1,8.21-26.48-.77-.74-8.08,26.05-.91-1.13-5.62-34.17-1-.31,5.54,33.7-1.08-.2-17.36-33-.86.43,17.37,33-.44,1-24.91-23.89c-.11.33-.23.67-.33,1l25.27,24.23.41,1.39-26.51-8.23c0,.35.1.7.16,1.05l26.95,8.37.58.92L305.2,323l.44.85L326.36,313l.44,1-8.45,27.22.77.75,8.31-26.79.91,1.12,5.78,35.16,1,.3L329.44,317l1.08.2L348.27,351c.28-.14.56-.3.83-.46L331.37,316.8l.44-1,25.11,24.08c.11-.34.21-.69.3-1l-25.43-24.39-.41-1.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.39,297.61c-3.23-2-6.19-2.27-8.36-1-.45.26-1,.48-1.57.79a4.34,4.34,0,0,0-.46.28l-.08,0,0,0a6,6,0,0,0-.59.44l-.12.12a4.45,4.45,0,0,0-.48.49c-.06.06-.11.13-.17.2s-.26.34-.38.52l-.18.31c-.1.17-.2.34-.29.52s-.13.29-.19.43-.14.34-.21.53-.11.37-.16.56-.1.33-.14.5-.1.5-.14.76-.06.28-.07.43a10.5,10.5,0,0,0-.11,1.29c-.29,7.41,4.57,16.64,10.85,20.61q.58.36,1.17.66a6.71,6.71,0,0,0,.68.3l.46.21.47.15.65.21.26.05c.28.06.56.12.83.15h.05a6.11,6.11,0,0,0,3.83-.74c.58-.31,1.09-.54,1.74-.89,2.09-1.16,3.45-3.69,3.6-7.32C341.54,310.8,336.67,301.57,330.39,297.61Zm-4.19,22.23c-1.94-1.64-4.55-6.45-5.55-9.12a21.47,21.47,0,0,0,2,1.32c3,1.68,3-.44,4.15,1.08s.79,5.12-.24,6.95A1.75,1.75,0,0,1,326.2,319.84Zm6.44-13.56a3,3,0,0,0-.51.21l-1.82.94a2.24,2.24,0,0,0-.93.86c-1.44-1.59-3-6.53-2.76-8.82,2.57,1,6.76,4.78,7.38,6.2a2.19,2.19,0,0,1,.11.34A7.39,7.39,0,0,0,332.64,306.28Zm-8.78-1.88c.84,3.55,2.3,4.15,2.35,5.3-2.28-.46-5.91-2.83-6.08-5.05a8.88,8.88,0,0,1,2.25-5.82C323.33,299.29,323.18,301.49,323.86,304.4Zm5.86,18.7c-1.17-1.15.22-2.18.93-4.45a6.25,6.25,0,0,0,.1-3.33c2.31,2,5.69,7.05,4.71,8.48a1.49,1.49,0,0,1-.12.14C333.32,324.38,330.54,323.92,329.72,323.1Zm6-7.42c-2.39-3.48-3.44-2.36-4-4.19a2.31,2.31,0,0,1,.91-2.39,3,3,0,0,1,3.62,1.38c1.15,2.24,1.68,6.26,1.64,8.75C337.32,318.3,336.62,317,335.7,315.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.39,297.61c-3.23-2-6.19-2.27-8.36-1-.45.26-1,.48-1.57.79a4.34,4.34,0,0,0-.46.28l-.08,0,0,0a6,6,0,0,0-.59.44l-.12.12a4.45,4.45,0,0,0-.48.49c-.06.06-.11.13-.17.2s-.26.34-.38.52l-.18.31c-.1.17-.2.34-.29.52s-.13.29-.19.43-.14.34-.21.53-.11.37-.16.56-.1.33-.14.5-.1.5-.14.76-.06.28-.07.43a10.5,10.5,0,0,0-.11,1.29c-.29,7.41,4.57,16.64,10.85,20.61q.58.36,1.17.66a6.71,6.71,0,0,0,.68.3l.46.21.47.15.65.21.26.05c.28.06.56.12.83.15h.05a6.11,6.11,0,0,0,3.83-.74c.58-.31,1.09-.54,1.74-.89,2.09-1.16,3.45-3.69,3.6-7.32C341.54,310.8,336.67,301.57,330.39,297.61Zm-4.19,22.23c-1.94-1.64-4.55-6.45-5.55-9.12a21.47,21.47,0,0,0,2,1.32c3,1.68,3-.44,4.15,1.08s.79,5.12-.24,6.95A1.75,1.75,0,0,1,326.2,319.84Zm6.44-13.56a3,3,0,0,0-.51.21l-1.82.94a2.24,2.24,0,0,0-.93.86c-1.44-1.59-3-6.53-2.76-8.82,2.57,1,6.76,4.78,7.38,6.2a2.19,2.19,0,0,1,.11.34A7.39,7.39,0,0,0,332.64,306.28Zm-8.78-1.88c.84,3.55,2.3,4.15,2.35,5.3-2.28-.46-5.91-2.83-6.08-5.05a8.88,8.88,0,0,1,2.25-5.82C323.33,299.29,323.18,301.49,323.86,304.4Zm5.86,18.7c-1.17-1.15.22-2.18.93-4.45a6.25,6.25,0,0,0,.1-3.33c2.31,2,5.69,7.05,4.71,8.48a1.49,1.49,0,0,1-.12.14C333.32,324.38,330.54,323.92,329.72,323.1Zm6-7.42c-2.39-3.48-3.44-2.36-4-4.19a2.31,2.31,0,0,1,.91-2.39,3,3,0,0,1,3.62,1.38c1.15,2.24,1.68,6.26,1.64,8.75C337.32,318.3,336.62,317,335.7,315.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.56,298.55c-6.28-4-11.61-1.15-11.9,6.27s4.57,16.64,10.85,20.61,11.6,1.15,11.89-6.27S334.84,302.51,328.56,298.55Zm-2.92.68c2.3.12,7.66,4.82,8.36,6.44s-1.3,1-3.18,1.55c-2.39.74-1.36,3.07-2.72,2.44C326.11,308.74,323.35,299.1,325.64,299.23Zm-3.45-.49c1.18.25.94,2.56,1.67,5.66.93,3.93,2.61,4.24,2.32,5.68-.44,2.12-7.64-1.35-7.87-4.49S321,298.48,322.19,298.74Zm2.18,22c-2.43-2-6-9.21-5.95-10.68s1.89.63,4.22,2c3,1.68,3-.44,4.15,1.08C328.52,315.34,326.82,322.84,324.37,320.77Zm11.09,3c-1.28,1.86-6.39,1.4-7.56.25s.23-2.19.94-4.46c.89-2.88-.77-4.52.25-5C330.58,313.83,336.74,321.93,335.46,323.8Zm-1.57-7.19c-2.4-3.47-3.45-2.35-4-4.18-.8-2.67,4.7-5.16,6.35-1.95s2,10.09,1.28,10.84S335.78,319.34,333.89,316.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.87,316.1c1.92,1.21,3.55.35,3.64-1.92a7.87,7.87,0,0,0-3.32-6.3c-1.92-1.21-3.55-.36-3.64,1.91A7.91,7.91,0,0,0,327.87,316.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,397.24l-12.59-29.47h0l-4-9.41A35.39,35.39,0,0,0,395.78,343l-.16,4.09a32.06,32.06,0,0,1,9.64,12.58l1.92,4.49-10.35-6.42-.15,3.9,12.82,7.95,12.36,28.95a1.68,1.68,0,0,0,1.5,1,1.69,1.69,0,0,0,1.62-2.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.08,355.1c-5.15,8.88-4,20.49-4,24.44s-1.93,3.11-2.92-.11-3.44-16.29,2-27.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.17,383.65c.29-7.29-4.49-16.36-10.66-20.25-3.24-2-6.21-2.24-8.35-.92h0l-5,2.56,15.31,28.5L392.4,391v0C394.58,389.89,396,387.37,396.17,383.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.23,366.16c6.17,3.89,10.94,13,10.66,20.25s-5.52,10-11.7,6.15-10.94-13-10.66-20.25S374.05,362.26,380.23,366.16Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M379.89,374.71a8.91,8.91,0,0,1,3.75,7.13c-.1,2.57-1.94,3.54-4.11,2.17a8.89,8.89,0,0,1-3.76-7.13C375.87,374.31,377.72,373.34,379.89,374.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384.71,354.59c-5.15,8.88-4,20.49-4,24.45s-1.92,3.1-2.91-.12-3.44-16.28,2-27.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.67,359.56l-46.76-30.28-.2,5.06,39.86,25.73h0l5.13,3.3.9.57a2.33,2.33,0,0,0,3.58-2.1l-.25-4.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.81 442.44 338.38 428.29 413.46 388.75 435.9 402.9 360.81 442.44",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.38 428.29 338.18 433.59 360.61 447.74 360.81 442.44 338.38 428.29",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.38 428.29 338.18 433.59 360.61 447.74 360.81 442.44 338.38 428.29",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.9 402.9 435.7 408.2 360.61 447.74 360.81 442.44 435.9 402.9",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.9 402.9 435.7 408.2 360.61 447.74 360.81 442.44 435.9 402.9",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.91,377.75a1.7,1.7,0,0,1,2.34-.53l1.41.89a35.38,35.38,0,0,1,13.72,16.1l4,9.4h0L344,433.09a1.69,1.69,0,0,1-1.63,2.36,1.69,1.69,0,0,1-1.49-1L328.5,405.47l-16.56-10.28a1.69,1.69,0,1,1,1.78-2.88L326.18,400l-1.92-4.5A31.94,31.94,0,0,0,311.85,381l-1.41-.89A1.7,1.7,0,0,1,309.91,377.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.31,396.85c-5.15,8.88-4,20.5-4,24.45s-1.93,3.1-2.92-.12-3.44-16.28,2-27.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.4,425.4c.29-7.29-4.49-16.36-10.66-20.25-3.24-2-6.21-2.23-8.35-.92h0l-5,2.56,15.32,28.51,4.91-2.56v0C314.81,431.64,316.26,429.12,316.4,425.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,407.91c6.18,3.89,10.95,13,10.66,20.25s-5.51,10-11.69,6.15-10.94-12.95-10.66-20.25S294.28,404,300.45,407.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.12,416.46a8.92,8.92,0,0,1,3.75,7.13c-.1,2.57-1.94,3.54-4.11,2.17a8.89,8.89,0,0,1-3.76-7.13C296.1,416.06,298,415.09,300.12,416.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.94,396.34c-5.15,8.88-4.05,20.5-4,24.45s-1.92,3.1-2.91-.12-3.45-16.28,2-27.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.08,375.77c.33,0,.6,3.36-1.28,4.64-2.17,1.48-8.39,3.73-16.32,2.24s-12.09-4-15.12-6.68-7.28-6.4-10.85-7.37c-3.31-.9-6.86-2.53-7.87-3.55s-.57-5.21-.57-5.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.34,343.87a1.26,1.26,0,0,0-1.27.9c-.33,1.14-.82,4.5-1.48,6.36-.91,2.6-1.77,8-1.47,10.16s5.66,4,9.08,5.51a45.46,45.46,0,0,1,10.88,7.28c3.56,3.08,11.26,6.55,16.47,6.87,6.16.37,13.22-1,15-3.47,2.18-3.09,3.87-6.74-5-11.21-1.68-.85-7.53-4.54-9.52-5.86-5.39-3.6-9.13-6.81-11.32-12.67a3.18,3.18,0,0,0-1.19-1.83,3.22,3.22,0,0,0-1.77-.27c-1.53.1-7.65.45-9.08,1-1.26.45-3,.95-3.12,2.38a4.42,4.42,0,0,0,.25,1.48c.09.3.15.69-.14.85s-.62-.07-.84-.28a20.88,20.88,0,0,1-2.28-2.86,8.42,8.42,0,0,0-1.36-1.44,14.69,14.69,0,0,1-1.5-1C223.15,345.16,223.33,344.54,223.34,343.87Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.34,343.87a1.26,1.26,0,0,0-1.27.9c-.33,1.14-.82,4.5-1.48,6.36-.91,2.6-1.77,8-1.47,10.16s5.66,4,9.08,5.51a45.46,45.46,0,0,1,10.88,7.28c3.56,3.08,11.26,6.55,16.47,6.87,6.16.37,13.22-1,15-3.47,2.18-3.09,3.87-6.74-5-11.21-1.68-.85-7.53-4.54-9.52-5.86-5.39-3.6-9.13-6.81-11.32-12.67a3.18,3.18,0,0,0-1.19-1.83,3.22,3.22,0,0,0-1.77-.27c-1.53.1-7.65.45-9.08,1-1.26.45-3,.95-3.12,2.38a4.42,4.42,0,0,0,.25,1.48c.09.3.15.69-.14.85s-.62-.07-.84-.28a20.88,20.88,0,0,1-2.28-2.86,8.42,8.42,0,0,0-1.36-1.44,14.69,14.69,0,0,1-1.5-1C223.15,345.16,223.33,344.54,223.34,343.87Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.08,374.08c-1.51-1.3-3.12-2.57-4.75-3.72h0s10.34,6.68,14.86,4.27c2.92-1.55,1.73-3.76,1.71-4.44s10.17-4.78,12.91-4.89h0c.73.43,1.34.78,1.73,1,8.87,4.47,7.18,8.12,5,11.21-1.77,2.49-6.93,4.18-14.89,3.65C250.44,380.77,242.64,377.16,239.08,374.08Z",
    style: {
      fill: "#845EC2",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.08,374.08c-1.51-1.3-3.12-2.57-4.75-3.72h0s10.34,6.68,14.86,4.27c2.92-1.55,1.73-3.76,1.71-4.44s10.17-4.78,12.91-4.89h0c.73.43,1.34.78,1.73,1,8.87,4.47,7.18,8.12,5,11.21-1.77,2.49-6.93,4.18-14.89,3.65C250.44,380.77,242.64,377.16,239.08,374.08Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28,368.16c5.54,2.46,3.05,3.26,1.45,3.36s-10.82-5.64-16.37-10.24c-5.78-4.79-9.29-9.85-11.44-11.61-.8-.66-1.66-1.46-2.42-2.2.23-1.13.42-2.16.57-2.7a1.26,1.26,0,0,1,1.27-.9c0,.67-.19,1.29.33,1.83a14.69,14.69,0,0,0,1.5,1,8.42,8.42,0,0,1,1.36,1.44,20.88,20.88,0,0,0,2.28,2.86C233.38,357.1,244.74,365.71,250.28,368.16Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.37,370.73a.57.57,0,0,1-.34-.14.47.47,0,0,1,0-.72c1.72-1.69,9.6-5.42,13.75-4.72a.52.52,0,0,1,.46.6.53.53,0,0,1-.65.41c-3.87-.64-11.37,3.08-12.74,4.41A.57.57,0,0,1,251.37,370.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.61,367.62a.64.64,0,0,1-.35-.14.49.49,0,0,1,0-.73c1.72-1.68,9.6-5.41,13.76-4.71a.53.53,0,0,1,.46.6.55.55,0,0,1-.65.41c-3.88-.64-11.38,3.08-12.74,4.41A.62.62,0,0,1,246.61,367.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.83,364.65a.67.67,0,0,1-.35-.14.49.49,0,0,1,0-.73c1.73-1.68,9.61-5.41,13.76-4.71a.53.53,0,0,1,.46.6.54.54,0,0,1-.65.41c-3.88-.64-11.38,3.08-12.74,4.41A.58.58,0,0,1,241.83,364.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.44,361.33a.54.54,0,0,1-.34-.14.48.48,0,0,1,0-.72c1.73-1.68,9.63-5.41,13.76-4.71a.52.52,0,0,1,.46.59.55.55,0,0,1-.65.42c-3.87-.65-11.37,3.07-12.74,4.4A.57.57,0,0,1,237.44,361.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.15,358a.59.59,0,0,1-.34-.13.49.49,0,0,1-.05-.73c2.38-2.39,10.57-5.39,14.72-4.7a.53.53,0,0,1,.46.6.54.54,0,0,1-.65.41c-3.73-.62-11.58,2.27-13.69,4.39A.58.58,0,0,1,233.15,358Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.32,386.08c-.83,4.76-2.11,7.82-4.59,10.32s-6.71,2.79-10.83,1.35-9.3-4.44-10.09-8.77-.28-7.15,1.11-11.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,348.74c-1.74-.15-2.88,6.25-4.52,12.58-1.75,6.79-4.7,9.27-6.21,14.83-1.73,6.34-1.58,9.31,1,13.68s12.55,9.73,18.22,4.84c4.62-4,5.3-9.05,5.55-15.6.27-6.77.38-11.55,1.24-16.59.81-4.82,1.71-9.48.26-10.24-.19.7-.39,1.59-.58,2.27s-.58,3.14-1.56,3a8.05,8.05,0,0,1,.17-1.83,1.85,1.85,0,0,0-.33-1.64,3.85,3.85,0,0,0-1.85-.95c-1.68-.51-3.37-1-5.09-1.37-.86-.19-1.72-.35-2.59-.47a8.72,8.72,0,0,0-2.22-.07,1.4,1.4,0,0,0-1,.52,1.53,1.53,0,0,0-.16.73,4.47,4.47,0,0,1-.35,1.3c-.08.19-.28.4-.52.31a.4.4,0,0,1-.25-.43c.08-.79.26-1.34.4-2.24.06-.42.2-1,.25-1.41S162.94,349.15,163,348.74Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,348.74c-1.74-.15-2.88,6.25-4.52,12.58-1.75,6.79-4.7,9.27-6.21,14.83-1.73,6.34-1.58,9.31,1,13.68s12.55,9.73,18.22,4.84c4.62-4,5.3-9.05,5.55-15.6.27-6.77.38-11.55,1.24-16.59.81-4.82,1.71-9.48.26-10.24-.19.7-.39,1.59-.58,2.27s-.58,3.14-1.56,3a8.05,8.05,0,0,1,.17-1.83,1.85,1.85,0,0,0-.33-1.64,3.85,3.85,0,0,0-1.85-.95c-1.68-.51-3.37-1-5.09-1.37-.86-.19-1.72-.35-2.59-.47a8.72,8.72,0,0,0-2.22-.07,1.4,1.4,0,0,0-1,.52,1.53,1.53,0,0,0-.16.73,4.47,4.47,0,0,1-.35,1.3c-.08.19-.28.4-.52.31a.4.4,0,0,1-.25-.43c.08-.79.26-1.34.4-2.24.06-.42.2-1,.25-1.41S162.94,349.15,163,348.74Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.85,374.35c-.26.92-1.89,7,.18,8.42,2.24,1.56,4-3.14,4-3.14s5.65-.51,13.43,3.4c-.51,1,.4,4.45,2.68,4.07s3.83-7.38,3.85-7.47c-.28,6.28-1,11.17-5.53,15-5.67,4.89-15.67-.48-18.22-4.84s-2.7-7.34-1-13.68C152.45,375.51,152.64,374.92,152.85,374.35Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.85,374.35c-.26.92-1.89,7,.18,8.42,2.24,1.56,4-3.14,4-3.14s5.65-.51,13.43,3.4c-.51,1,.4,4.45,2.68,4.07s3.83-7.38,3.85-7.47c-.28,6.28-1,11.17-5.53,15-5.67,4.89-15.67-.48-18.22-4.84s-2.7-7.34-1-13.68C152.45,375.51,152.64,374.92,152.85,374.35Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.63,380.14c-.27,2.35-3.18,1.12-3-2.22s3.3-10.88,3.84-16.6c1.64-6.33,2.78-12.73,4.52-12.58l0,.24-.55,3.25a12.38,12.38,0,0,0-.24,1.4c-.51,4.79-2.29,13.93-3.25,18.24A58.78,58.78,0,0,0,157.63,380.14Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.54,382.83a58.86,58.86,0,0,0,2.46-8c1-4.26,3.42-13.15,5.07-17.72a9.65,9.65,0,0,0,.87-2.59c.18-.64.36-1.45.54-2.12,0-.05,0-.1,0-.15,1,.57.86,3.18.37,6.41-.4,1.85-1,4.12-1.84,6.86-2,5.38-2.54,13.55-3.84,16.64S168.75,385.06,169.54,382.83Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.62,383.24a.7.7,0,0,1-.23-.08,26.47,26.47,0,0,0-13.23-3,.73.73,0,0,1-.76-.47c-.06-.28.17-.53.52-.55a27.8,27.8,0,0,1,14.16,3.24.46.46,0,0,1,.2.71A.66.66,0,0,1,170.62,383.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.57,378.35a.6.6,0,0,1-.21-.08,33,33,0,0,0-14.82-3.37.74.74,0,0,1-.74-.49c-.05-.28.19-.52.54-.53A34.24,34.24,0,0,1,173,377.45c.31.17.42.49.24.71A.66.66,0,0,1,172.57,378.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.43,370.11a.68.68,0,0,1-.51-.41c-.09-.28.12-.54.46-.58,8-.91,15.34,3.27,15.65,3.45s.4.5.21.72a.74.74,0,0,1-.89.08c-.07,0-7.23-4.1-14.64-3.24A.86.86,0,0,1,158.43,370.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.33,365.6a.67.67,0,0,1-.51-.4c-.1-.28.1-.54.45-.59a25.67,25.67,0,0,1,16,3.47.46.46,0,0,1,.15.72.76.76,0,0,1-.9,0,24.54,24.54,0,0,0-14.88-3.21A.86.86,0,0,1,159.33,365.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,360.54a.67.67,0,0,1-.51-.4c-.1-.27.1-.54.44-.58,8.23-1.17,15.76,3.42,16.07,3.62a.46.46,0,0,1,.17.71.74.74,0,0,1-.9.06c-.07-.05-7.34-4.47-15-3.39A.7.7,0,0,1,160.36,360.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.94,170c-4.36,44.95-7.63,106.2-7.63,106.2-.38,3.41-2.9,9.23-4.85,26.06-2.06,17.76-4.07,51.05-4.07,51.05s12.32,6.91,22.46,3.73c0,0,10.78-47.21,16.33-68.08,5.24-19.75,13.56-57.21,13.56-57.21l4.55,37.29s-.92,12.82-.7,21.8c.26,10.45,4.22,58.27,4.22,58.27s16.87,7.1,27.48-.73c0,0,3.3-65.7,3.82-78.26,1-24.62.9-72.25.57-104.07Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.94,170c-4.36,44.95-7.63,106.2-7.63,106.2-.38,3.41-2.9,9.23-4.85,26.06-2.06,17.76-4.07,51.05-4.07,51.05s12.32,6.91,22.46,3.73c0,0,10.78-47.21,16.33-68.08,5.24-19.75,13.56-57.21,13.56-57.21l4.55,37.29s-.92,12.82-.7,21.8c.26,10.45,4.22,58.27,4.22,58.27s16.87,7.1,27.48-.73c0,0,3.3-65.7,3.82-78.26,1-24.62.9-72.25.57-104.07Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.74,231.77l4.84-24.58s12.25-1.56,18.61-7.07c0,0-4.17,7.36-15.75,10.07l-4.75,21.7,1.6,37.17Z",
    style: {
      fill: "#845EC2",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.17,82.24c13.5,3.76,13,11.05,16.19,24.52,2.68,11.43,6.79,27.87,6.79,27.87s9.82,16.36,16.7,27l-14.46,11.2a133.82,133.82,0,0,1-15.63-14.95c-5.24-6-5.86-6.24-9.2-15.42-2.55-7-7.86-25.8-7.86-25.8Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.52,178.94a18.75,18.75,0,0,0-3.77-6.33c3.25-5.36,7.2-9.61,14.1-11,2.67,4.13,5.59,7.3,7,10.14a35.74,35.74,0,0,1,3.29,18.49l-6.08-3.83c-3.81-2.2-7.67,4.37-7.79,7s.63,4.08.13,5.7-2.8,3.21-3.9.78-3.25-5.72-3.45-9.73S269,181.52,268.52,178.94Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.84,87.19s-8,6.38-4.55,22.47c2.7,12.62,3.34,26.31,3.62,31.83.43,8.46-1,34.48-1,34.48,12.5,15.5,70.62,12.59,77.5-1.18,0,0,.51-52.83-4-72-2.55-10.88-5.2-16.72-9.26-19.87l-21.79-3.94-11.92-1.22Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.84,87.19s-8,6.38-4.55,22.47c2.7,12.62,3.34,26.31,3.62,31.83.43,8.46-1,34.48-1,34.48,12.5,15.5,70.62,12.59,77.5-1.18,0,0,.51-52.83-4-72-2.55-10.88-5.2-16.72-9.26-19.87l-21.79-3.94-11.92-1.22Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.43,77.71l-8.91,3a58.54,58.54,0,0,0,6.93,12.23c4,5,13.38,12.35,20.72,15.19,3.3-8.34,4.63-14.22,4-20.26a29.25,29.25,0,0,0-1.61-7.25L216.63,79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.17,82.24l-16.34-4.53-.24,2.59a24.89,24.89,0,0,1,9.11,9.26c4.2,7.74,9.56,10.21,10.6,35.54.7,17.05.13,116.29.13,116.29s5,3,9.59.64V147.6C252,131.55,252.37,95.92,239.17,82.24ZM199.3,77.53,175,86.7c-7.42,7.55-5.87,15.52-3.79,32.46s.53,39.75,0,50.05S165,241.53,165,241.53c7.3,9.12,31.14,7,31.14,7s8.47-125,6.91-141.11S199.3,77.53,199.3,77.53Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.68,20.5c-20-1.26-26.77,8.11-29.11,17.37s3.29,22,8.87,30.86L238,44.93C241.94,35.52,236,21.45,220.68,20.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.92,67.76c-1.29,4.44-3.92,7.68-8,8.27a30.52,30.52,0,0,1-5.9,0l-.15,1.65-.24,2.58c3.92,5.44,1.38,9.77-2.7,10.27-7.15.86-15.51-4.07-20-9.29-.35-2.38-.56-3.75-.56-3.75l1.44-14.14s-2,2.37-5.69.89c-2.82-1.14-6.5-6.53-4.37-10.94s6.9-3.49,8.16-2.15,1.53,3.48,3.51,3.2c1.05-.14,2.11-1.78,1.86-5.44,2.45-3.15,3.32-6,2.64-11.32,9.76-6,26.35-4.81,30.92-1.18C239.54,43.64,239,60.61,236.92,67.76Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,76.06c-6.56-.72-15.29-3.94-17.35-7a22.33,22.33,0,0,1-2.81-5.5s.08,4.1,1.64,6.75,8,7.31,18.3,8.13Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.29,48.69a1.94,1.94,0,1,1-1.92-2A2,2,0,0,1,219.29,48.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.91,40.6l-4.34,2.82a2.72,2.72,0,0,1,.79-3.67A2.53,2.53,0,0,1,217.91,40.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.8,44.27,231,44a2.29,2.29,0,0,1,2.43-2.26A2.5,2.5,0,0,1,235.8,44.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.44,49.12a1.94,1.94,0,1,1-1.92-2A2,2,0,0,1,235.44,49.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.21,59.54l7.11-2.85c-.93-1.4-6-10.71-9-11.49C224.34,45.19,226.21,59.54,226.21,59.54Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.88,60.52l6.34,2.55a3.35,3.35,0,0,1-4.39,2A3.59,3.59,0,0,1,218.88,60.52Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.68,61.51a3.53,3.53,0,0,0,2.15,3.58,3.29,3.29,0,0,0,2.29,0A5.26,5.26,0,0,0,218.68,61.51Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mask--inject-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.35,53.52c8.92,2.83,16.66,1.85,24.52-1.44a3.8,3.8,0,0,1,4.95,1.66s5.39,1.09,7.32-1.05c1.15,6.61-.83,18.75-6.69,22.39S216,76.94,211.32,73.91A16.89,16.89,0,0,1,205,66.59L205.19,56l-1.64-.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.14,52.69c-1.93,2.14-8.27.55-8.27.55a2.44,2.44,0,0,0-.36-.32l-.31.64c1.39,6.5,0,17.61-2.89,23.3a13.88,13.88,0,0,0,5.14-1.78C238.31,71.44,240.29,59.3,239.14,52.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.4,55.45c4.35-1.36,6.33-2.54,8.49-.82,2,1.55,6.73,1.24,8.47-.1,0-.65,0-1.52,0-2-3.08,1.94-7.16.69-7.16.69a4.5,4.5,0,0,0-5.39-1.38,34.41,34.41,0,0,1-24.42,1.72s-3.09-1.12-1.09.49a10.25,10.25,0,0,0,3.93,2A31.71,31.71,0,0,0,222.4,55.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.04 66.59 200.79 66.13 200.88 64.13 205.07 64.53 205.04 66.59",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M196.87,109.06c0-1-.3-6.67-.39-9.4a153.34,153.34,0,0,1,.89-22.3c.27-1.89.65-3.17,2.26-3l-.33,3.22a124.47,124.47,0,0,0-1.06,21.12c.09,2.79.47,9.25.51,10.35Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.19,153.17H193l.07-1.31a8.59,8.59,0,0,0,4.34-1.53,15.92,15.92,0,0,1-3.53-3.31c-2.07-2.77-6.36-22.4-4.85-26.92,1.26-3.8,5.16-12.15,8.5-12.24h.09c3.33.06,7.57,8.1,9,11.79,1.74,4.45-1.56,24.27-3.49,27.14a16.09,16.09,0,0,1-3.36,3.48,8.39,8.39,0,0,0,4.41,1.31l.14,1.3a10.17,10.17,0,0,1-5.71-1.76A10.55,10.55,0,0,1,193.19,153.17Zm4.44-44h0c-2,0-5.59,6.24-7.28,11.33-1.39,4.16,2.73,23.15,4.65,25.72a15.35,15.35,0,0,0,3.65,3.3,15.39,15.39,0,0,0,3.47-3.47c1.79-2.67,4.95-21.84,3.36-25.93C203.5,115.16,199.61,109.21,197.63,109.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.22,152.18a1.93,1.93,0,1,1-2-1.88A1.93,1.93,0,0,1,206.22,152.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,152.46a1.93,1.93,0,1,1-2-1.88A1.93,1.93,0,0,1,195,152.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.84,128.27l-1.1-.09a.43.43,0,0,1-.39-.47c.28-3.67.21-6.37-.22-7.46-1.86-4.77-5.77-10.79-7.53-10.74s-5.36,6.25-7,11.11c-.37,1.11-.31,3.81.16,7.45a.43.43,0,0,1-.37.49l-1.1.15a.43.43,0,0,1-.48-.38c-.54-4.09-.56-6.9-.08-8.34.86-2.6,4.9-12.36,8.8-12.45s8.42,9.44,9.42,12c.55,1.41.67,4.21.34,8.33A.44.44,0,0,1,206.84,128.27Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.89,77.09l-.21,2.25.14.07A15.75,15.75,0,0,1,225.13,81a16.13,16.13,0,0,1,2.55,2.69A30.87,30.87,0,0,1,231,90.23c2.72,6.45,3.71,17.39,3.88,30.08l2.13.32c0-4.52.25-19.53-4-30.87C230.23,82.24,226,78.59,222.89,77.09Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.93,118.3a6.3,6.3,0,1,0,6.88-5.67A6.32,6.32,0,0,0,229.93,118.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.64,118.56a3.58,3.58,0,1,0,3.91-3.22A3.58,3.58,0,0,0,232.64,118.56Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238,228.56l4.72-7.46-18.27-11.52h0a2.19,2.19,0,0,0-2.24.11,6.91,6.91,0,0,0-3.33,5.28,2.22,2.22,0,0,0,.79,2h0l0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.18,226.51c-.08,2,1.29,2.85,3,1.92a6.91,6.91,0,0,0,3.33-5.28c.07-2-1.29-2.85-3.05-1.92A6.89,6.89,0,0,0,237.18,226.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.6,223a1.12,1.12,0,0,1,.94-.11l.24.16,12.74,8-4.25,2.24-10.6-6.69-.46-.28a1.23,1.23,0,0,1-.21-.8A3.36,3.36,0,0,1,240.6,223Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.49,201.45,294.2,194l-18.26-11.52h0a2.17,2.17,0,0,0-2.24.11,6.89,6.89,0,0,0-3.33,5.28,2.22,2.22,0,0,0,.79,2h0l0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.37,178.41c9.59-.46,17.26.24,15.13,9.68-3.84-2.21-7.78,3-7.9,5.61s.61,4.09.11,5.72-3.19,3-4.29.57-3.27-5.75-3.47-9.78S268.87,181,268.37,178.41Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.66,199.4c-.08,2,1.28,2.84,3,1.92A6.91,6.91,0,0,0,295,196c.07-2-1.29-2.85-3.05-1.93A6.93,6.93,0,0,0,288.66,199.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.08,195.88a1.17,1.17,0,0,1,.94-.12l.24.17L306,204l-4.25,2.24-10.6-6.69-.46-.28a1.23,1.23,0,0,1-.21-.8A3.34,3.34,0,0,1,292.08,195.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.1,224.19,298,229l81.25,42.39a20.7,20.7,0,0,1,8.8,14.44l8.47,73.78a1.27,1.27,0,0,0,1.85,1h0c.43-.23.7-.69.62-2.47l-3.44-78.19c-.19-4.42-2.8-9.78-7.13-13.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.08,359.29l-67.21-42.41a9.63,9.63,0,0,1-4.05-7.7l.16-4.05a9.62,9.62,0,0,1,4.64-7.36l70.31-37a9.62,9.62,0,0,1,8.69.34l67.2,42.38a9.6,9.6,0,0,1,4.05,7.7l-.16,4.1a9.58,9.58,0,0,1-4.64,7.36l-70.3,37A9.61,9.61,0,0,1,308.08,359.29Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.33,359.89a6.88,6.88,0,0,1-1.25-.6l-67.21-42.41a9.66,9.66,0,0,1-4.05-7.7l.16-4.05a9.75,9.75,0,0,1,3.8-6.81c-1.6,1.32-1.4,3.18.64,4.47L308.31,345Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.88,311.18l-.17,4.1a9.56,9.56,0,0,1-4.64,7.36l-70.3,37a9.71,9.71,0,0,1-7.44.24l-1-14.91.32.2a9.55,9.55,0,0,0,8.69.34l70.31-37c2.14-1.12,2.48-3,1-4.41A9.78,9.78,0,0,1,391.88,311.18Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.84,275.83l-70.32,37a9.09,9.09,0,0,1-5.13.8,6.63,6.63,0,0,1-.76-.11l-.16,0-.45-.1-.06,0a5.67,5.67,0,0,1-.67-.2,7.51,7.51,0,0,1-1.46-.68l-3.46-2.18a12.29,12.29,0,0,1-4.93-7.65l-8.18-58.78a6.58,6.58,0,0,1,0-1.09l0-.43a7.94,7.94,0,0,1,.56-2.11,7.69,7.69,0,0,1,2.43-3.19l.3-.22a4.53,4.53,0,0,1,.48-.27l70.3-37a9.61,9.61,0,0,1,8.69.34l3.46,2.18a9.46,9.46,0,0,1,2,1.78c.12.13.23.27.33.4A13.09,13.09,0,0,1,330,206c.08.13.15.26.22.4s.13.24.19.36.17.35.24.52a4.93,4.93,0,0,1,.22.53c.05.14.11.29.15.43a1.72,1.72,0,0,1,.07.21c0,.13.07.26.11.39s.08.34.11.51a2.29,2.29,0,0,1,.07.36l8.18,58.79A7.63,7.63,0,0,1,335.84,275.83Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.21,251.44l8.18,58.77c.38,2.75,2.68,3.93,5.13,2.64l70.31-37a7.65,7.65,0,0,0,3.75-7.32l-8.18-58.77c-.38-2.75-2.68-3.93-5.13-2.64l-70.31,37A7.69,7.69,0,0,0,252.21,251.44Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.21,251.44l8.18,58.77c.38,2.75,2.68,3.93,5.13,2.64l70.31-37a7.65,7.65,0,0,0,3.75-7.32l-8.18-58.77c-.38-2.75-2.68-3.93-5.13-2.64l-70.31,37A7.69,7.69,0,0,0,252.21,251.44Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.72,313.48a10.27,10.27,0,0,1-3.33.17,6.63,6.63,0,0,1-.76-.11l-.61-.13-.06,0a5.67,5.67,0,0,1-.67-.2,7.51,7.51,0,0,1-1.46-.68l-3.46-2.18a12.29,12.29,0,0,1-4.93-7.65l-8.18-58.78a6.58,6.58,0,0,1,0-1.09l0-.43a7.94,7.94,0,0,1,.56-2.11l12,7.45a7,7,0,0,0-.58,3.72l8.18,58.78c.28,2,1.63,3.22,3.32,3.15C263.71,313.41,263.72,313.44,263.72,313.48Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.62,339.31s7.44,33.44,10.75,43c2.14,6.15,8.85,13.13,14.27,18,1.18,1.06,3.76,3.05,4.78,3.84,2.25,1.75.71,3-1.27,3.56-4.65,1.24-9.34.34-14.85-2.8-6.34-3.63-9-6.69-14.6-11.11A22.5,22.5,0,0,1,385,389a6.59,6.59,0,0,1-.64-3.71,18.12,18.12,0,0,0-.24-4.15c-.9-4.61-16.67-30.61-16.67-30.61Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.18,408.31c.31,0,.84,3.34-.86,4.79-2,1.68-7.75,4.46-15.46,3.6s-11.91-3.09-15-5.53-7.48-5.88-11-6.58c-3.25-.64-6.78-2-7.83-2.95s-1-5.23-1-5.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.12,381.18c-1.24,0-1.48,1.26-1.32,2.26.9,5.54-1.43,10-.56,14.44.46,2.19,5.75,3.64,9.14,4.83a43.34,43.34,0,0,1,11,6.49c3.65,2.82,11.3,5.6,16.32,5.61,7.66,0,12.59-2.06,14.08-4.73,1.85-3.3.47-6.56-8.55-10-4.19-1.59-8-3.2-9.84-4.61-8.56-6.54-10-9.49-11.9-12.6-1-1.63-1.32-2.31-3.53-2.25-2.93.09-5.66.95-7.23,2.83-.82,1.36-.67,3-.67,4.56,0,.21.1.59-.21.51-1.22-1.2-1.29-3.28-2.56-4.53-.74-1-3.86-1.65-3.86-1.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.24,400.09c-11.08.88-16.63,7.76-17,11.85,6,2.57,9.22,2.86,11.51,2.87,7.66,0,12.9-2.06,14.4-4.73C434.85,407,433.22,402.44,424.24,400.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.23,402.08a.54.54,0,0,1-.34-.12.51.51,0,0,1-.09-.73,13.29,13.29,0,0,1,10-3.93.52.52,0,0,1,.49.56.53.53,0,0,1-.59.47,12.3,12.3,0,0,0-9,3.55A.58.58,0,0,1,408.23,402.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.33,398.48a.59.59,0,0,1-.35-.12.5.5,0,0,1-.08-.73,13.25,13.25,0,0,1,10-3.93.52.52,0,1,1-.1,1,12.26,12.26,0,0,0-9,3.55A.58.58,0,0,1,403.33,398.48Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.84,394.91a.56.56,0,0,1-.35-.11.51.51,0,0,1-.08-.73,13.29,13.29,0,0,1,10-3.94.53.53,0,0,1,.48.57.53.53,0,0,1-.59.47,12.3,12.3,0,0,0-9,3.55A.55.55,0,0,1,398.84,394.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.79,391.34a.53.53,0,0,1-.34-.11.51.51,0,0,1-.1-.73c2.09-2.61,6.86-4.37,10.89-4a.53.53,0,0,1,.49.57.53.53,0,0,1-.59.47c-3.63-.33-8.08,1.28-9.93,3.6A.53.53,0,0,1,394.79,391.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.19,358.48s7.44,33.44,10.75,43c2.14,6.15,8.85,13.13,14.27,18,1.18,1.06,3.76,3.05,4.78,3.84,2.24,1.75.7,3-1.28,3.57-4.64,1.23-9.34.33-14.84-2.81-6.34-3.62-9-6.69-14.61-11.11a22.74,22.74,0,0,1-4.7-4.71,6.65,6.65,0,0,1-.63-3.7,19.38,19.38,0,0,0-.24-4.16c-.9-4.6-16.68-30.61-16.68-30.61Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.74,427.48c.32,0,.84,3.35-.85,4.79-2,1.68-7.75,4.46-15.46,3.6s-11.91-3.09-15-5.53-7.48-5.88-11-6.57c-3.24-.65-6.77-2-7.82-3s-1-5.23-1-5.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.69,400.35c-1.25,0-1.49,1.26-1.33,2.26.9,5.54-1.42,10-.55,14.44.45,2.19,5.75,3.64,9.13,4.83a43.46,43.46,0,0,1,11,6.49c3.66,2.82,11.31,5.6,16.32,5.61,7.66,0,12.59-2.06,14.09-4.73,1.85-3.3.46-6.56-8.56-10-4.18-1.59-8-3.2-9.83-4.61-8.57-6.54-10-9.48-11.9-12.59-1-1.64-1.32-2.32-3.53-2.25-2.93.09-5.66.94-7.23,2.82-.83,1.36-.67,3-.68,4.56,0,.21.1.59-.21.51-1.22-1.2-1.29-3.28-2.56-4.53-.74-1-3.86-1.65-3.86-1.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.8,419.26c-11.07.88-16.62,7.77-17,11.85,6,2.57,9.21,2.87,11.5,2.87,7.66,0,12.91-2.06,14.4-4.73C401.42,426.14,399.78,421.61,390.8,419.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.8,421.25a.66.66,0,0,1-.35-.11.52.52,0,0,1-.08-.74,13.27,13.27,0,0,1,10-3.93.52.52,0,0,1,.49.56.53.53,0,0,1-.59.47,12.3,12.3,0,0,0-9,3.55A.55.55,0,0,1,374.8,421.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.89,417.65a.6.6,0,0,1-.34-.11.53.53,0,0,1-.09-.74,13.25,13.25,0,0,1,10-3.93.52.52,0,0,1,.49.56.53.53,0,0,1-.59.47,12.32,12.32,0,0,0-9,3.55A.53.53,0,0,1,369.89,417.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.4,414.09a.54.54,0,0,1-.34-.12.51.51,0,0,1-.09-.73,13.31,13.31,0,0,1,10-3.94.53.53,0,0,1,.49.57.53.53,0,0,1-.59.47,12.28,12.28,0,0,0-9,3.55A.56.56,0,0,1,365.4,414.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.35,410.51a.52.52,0,0,1-.33-.11.51.51,0,0,1-.1-.73c2.09-2.61,6.86-4.37,10.89-4a.53.53,0,0,1,.49.57.54.54,0,0,1-.59.47c-3.63-.33-8.08,1.29-9.93,3.6A.57.57,0,0,1,361.35,410.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.71,321.27c-1.92-9.16-3.14-11.84-9.41-17.19-8-6.85-13.91-10.85-22.57-16.88-9.27-6.45-21.53-15.12-21.53-15.12l-65,14.36c0,6.83.21,14.8,3.85,22.26,4.61,9.47,12.55,15.34,20.38,19.8,16.1,9.17,31.68,20.24,31.68,20.24s1.49,6.18,3.64,13c2.77,8.8,4.68,11.39,9.68,21.18,5.92,11.57,8.41,15.6,8.41,15.6s12.22,2.64,17.15-6c0,0-8.7-44.21-10.16-51.72-3.16-16.32-6.78-18.24-9.89-21l16.09,11.4a107.49,107.49,0,0,0,6.26,19.39c4,9.38,13.37,27.9,13.37,27.9,4.6,1.33,15.92-3.24,18.3-5.78C400,372.71,393.23,338.09,389.71,321.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.07,331.2,346,319.8,323.7,300.69c4.44-2.23,6.76-5.4,9.26-10.37C332.31,295.63,328,301,328,301Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288,159.86c-7.93,0-9.19,10.89-9.05,22.51s0,34.68,0,34.68h46.5V177.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.93,263.88c.2-.37-1.28-8.25-1.68-10.82-.68-4.29-1.21-6.57-1.21-6.57l-11.64-29.3-2.11-10.34s6.48-.44,9.8,1c4.29,1.82,5.76,4.47,9.13,11.38,2.9,5.91,10.33,25.19,11.09,28.43s.51,5.21-.48,10.23c-.76,3.88-1.49,7.69-2.59,11.92Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.8,250.36c2.1-3.31,8.54-4.35,13-2.76-5.68-4.53-12.38-1-13.57-.39C331.33,247.85,331.54,248.9,331.8,250.36Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.44,237.26c0-11.51,4.25-19.39,6.56-25.84l12.62-2.63s10-1.36,16.09-1.65,9.58-.29,9.58-.29c4.08,4.33,16.56,15.58,19.8,24.09a16.78,16.78,0,0,1-4.36,18.68c-.21,5.95-.1,11.08-.1,11.08s3.22,6.32,3.57,11.38c-.53,15.23-25.9,32.45-65.42,18.53a109,109,0,0,1,3.08-27.4C274.65,259.69,272.44,248.76,272.44,237.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.29,252s-5.06,6.13-15,4.93c-10.25-1.24-12.17-9.76-12.17-9.76s-.53,11.14,11.71,12.62A14.79,14.79,0,0,0,317.29,252Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M288,159.86c-5.82,1.52-6.87,8.33-5.48,17.44S292,196.79,292,196.79l36-17.2a14.75,14.75,0,0,0,3.61-13.4c-1.77-8.35-8.22-14.29-18-15.68S290.9,150.63,288,159.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.6,162.73a16.32,16.32,0,0,1,2.54,4.43c2.4,6.58,2.07,14.25,1.45,21.1-.77,8.5-3,12.4-6.8,14.41-1.84,1-5.25,1.86-10,1.06l-.12,5.65s11.06,8.33-1.86,9.25c-13.5,1-17.24-8.27-17.24-8.27l.56-20.7c-.76,1.23-5,3-7.93-.73-3.41-4.38-2.64-9.59.4-11.51s6.76-.09,8.15,3.47a3.9,3.9,0,0,0,4.55-1.44,8.93,8.93,0,0,0,1.52-2.71,18.62,18.62,0,0,0,.34-2.24c.16-.72.13-1,.84-1.08.55-.07,1.11,0,1.66-.09a13.86,13.86,0,0,0,3.12-.65,9.36,9.36,0,0,0,4.38-3.05,1.15,1.15,0,0,1,.49-.44,1.07,1.07,0,0,1,.47,0,10.66,10.66,0,0,0,12-8.18A22.25,22.25,0,0,1,323.6,162.73Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.43 178.53 316 188.72 322.13 186.36 315.43 178.53",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.48,183a3.54,3.54,0,0,1-.91.46,3.72,3.72,0,0,1-1.1.23,4.82,4.82,0,0,1-1.07-.13,2.76,2.76,0,0,1-.58-.16,1.89,1.89,0,0,1-.47-.3c-.08-.07-.09.1-.06.14a3.16,3.16,0,0,0,3.47.71,1.86,1.86,0,0,0,.75-.91S310.51,182.94,310.48,183Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.38,182.32a1.08,1.08,0,0,1-.24.12l-.24.14a3.42,3.42,0,0,1-.42.23,2.83,2.83,0,0,1-1,.25,4.41,4.41,0,0,1-1.2-.07,9.19,9.19,0,0,1-1-.36c-.06,0-.05.08,0,.11a2.84,2.84,0,0,0,2.43.79,3.32,3.32,0,0,0,1.12-.3,1.4,1.4,0,0,0,.42-.3,1.32,1.32,0,0,0,.2-.53S325.43,182.27,325.38,182.32Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.7,172.7a1.41,1.41,0,0,0-.79-.49,1.63,1.63,0,0,0-.49,0l-.24.05c-.08,0-.12,0-.14.12a.14.14,0,0,0,.06.16.24.24,0,0,0,.17,0l.25,0a2.7,2.7,0,0,1,.39.08l.14.07.07,0s0,0,0,0a.12.12,0,0,1,.05.05s0,0,0,0l0,0a.37.37,0,0,1,.07.12s0,0,0,0,0,0,0,.06v.06a.28.28,0,0,1,0,.09v0h0a.22.22,0,0,1,0,.08,1.36,1.36,0,0,1,0,.17c0,.12,0,.18-.09.3l0,.1s0,.07,0,.09,0,.14,0,.22.09.24.2.2a1.53,1.53,0,0,0,.21-.14.73.73,0,0,0,.16-.14l.09-.12a1.33,1.33,0,0,0,.09-.21,1.17,1.17,0,0,0,.05-.2A1.28,1.28,0,0,0,311.7,172.7Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.1,194.78c-1,.63-1.48-.57-3.17-1.28s-2.95,0-3-1.23c-.06-1,1.53-2.79,4.4-1.81C315.76,191.3,316,194.21,315.1,194.78Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.31,190.46a2.15,2.15,0,0,0-1.39,1.81c.06,1.22,1.35.54,3,1.23a8.36,8.36,0,0,1,1.72,1.06A4.88,4.88,0,0,0,310.31,190.46Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,203.73c-10.14-2.2-15.82-6.32-16.86-10.43,0,0,.64,5.37,3.48,7.74,4,3.32,13.32,5.49,13.32,5.49Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.12,179.81c-.29-1-1,.82-2.32,1.19s-2.61-.88-2.31.14a2.47,2.47,0,0,0,4.63-1.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.13,180.49c.16-1.05-1.18.33-2.37.14s-1.8-1.86-2-.8a2.21,2.21,0,0,0,4.33.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.92,172.31l3.69,2.93a2.26,2.26,0,0,1-3.26.43A2.45,2.45,0,0,1,320.92,172.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.89,173.35l-4.28,2.12a2.31,2.31,0,0,0,3.14,1.12A2.48,2.48,0,0,0,308.89,173.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.86,270.69c4.53,1.48,8,2.21,10,.63a28.82,28.82,0,0,1,5-3.12,15.39,15.39,0,0,1,4.87-1.53,18.66,18.66,0,0,1,3.92-.57c.42.11,2.24,1,4.69,1.89,1.18.41,1.35,2.94-1.11,3.63a12.62,12.62,0,0,1-4.83.29s1.31,2.25,2.65,2.35,4.45-.67,7.58-1.64,4.65-1.32,5.62.21c.27.38-2.74,3.11-2.74,3.11a9.06,9.06,0,0,1-.31,4.59c-.82,2.66-6.22,7.41-9.86,9.13a20.53,20.53,0,0,1-8.66,2c-2.51.13-6.69-1.53-9.89-2.71a75.31,75.31,0,0,0-10.3-2.6Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.6,277.51a3.88,3.88,0,0,0-1.8-2.42l-4.67-.16a11.93,11.93,0,0,1-5.28,3.46A34.68,34.68,0,0,0,319,280.9a3.79,3.79,0,0,0-1.18,1,3.72,3.72,0,0,0-.52,2.07,1.85,1.85,0,0,0,.19,1,1.93,1.93,0,0,0,1.59.68,16.6,16.6,0,0,0,4.5-.31c-1.24,1.77-4,2.14-4.89,4.12a4.16,4.16,0,0,0-.22,2.16,19.76,19.76,0,0,0,7.9-2c3.64-1.72,9-6.47,9.86-9.13a10.28,10.28,0,0,0,.46-2.72C336.65,277.71,336.63,277.61,336.6,277.51Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.77,262.29l-12.16-7.2a53.91,53.91,0,0,1-.36,6.88,3.65,3.65,0,0,1-2.2,2.93h0a6.12,6.12,0,0,0-1.91,1.13,39.58,39.58,0,0,1-4.06,3.25c-1.3.93-2.48,1.92-1.18,3.06a3.22,3.22,0,0,0,3.34.78,14.75,14.75,0,0,0,2.8-1.06,9.52,9.52,0,0,0,1.26,2.16l-1.08,1.35a19,19,0,0,1-2.64,2.25,33.66,33.66,0,0,1-4.15,2.25c-1.45.69-4,1.59-3.93,3.35s.82,1.39,2.44,1.18,7.14-1.88,7.14-1.88a17.76,17.76,0,0,1-2,2.09c-.77.61-2.69,2.41-4.34,3.69s-2.76,3.07-2.07,4.46,2.15.06,3.53-.69,2.53-1.29,2.53-1.29-1.33,1.32-2,1.94a2.54,2.54,0,0,0-.77,2.71c.46.91.92,1.18,2,.52s2.18-1.64,3.32-2.3a10.54,10.54,0,0,0,1.67-1.16s-1.47,1.71-1.22,2.6.93,1.4,1.6,1.09,2.23-1.9,3.43-2.51a17.63,17.63,0,0,0,2.85-2c.77-.57.91-1.14,1.34-2.69s.91-3,1.46-4.59c.64-1.93,1.3-3.75,2-5.85.78-2.4,1.64-3.81,2.41-7.2C344.73,267.78,344.63,266.81,344.77,262.29Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.49,259.89h0a13.94,13.94,0,0,1-.24,2.08,4.62,4.62,0,0,1-1,2.1h0a6.72,6.72,0,0,1,5.28-1.37c-.45-.54-2.1-.53-2.9-.53S332.43,261.09,332.49,259.89Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.2,267a3.13,3.13,0,0,0-1-.85,3,3,0,0,0-.64-.26l-.32-.07c-.09,0-.21,0-.29,0a.19.19,0,0,0,0,.25.66.66,0,0,0,.3.07l.27.06a3.1,3.1,0,0,1,.6.23,2.81,2.81,0,0,1,.9.71C331.19,267.27,331.27,267.07,331.2,267Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.06,267.44a2.76,2.76,0,0,0-.71-.45,1.63,1.63,0,0,0-.37-.13c-.1,0-.31-.1-.36,0a.15.15,0,0,0,0,.16.77.77,0,0,0,.39.14,1.93,1.93,0,0,1,.34.11,2,2,0,0,1,.61.33C330.1,267.72,330.14,267.51,330.06,267.44Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.12,280.11c-.09-.06-.11.13-.06.17a2.55,2.55,0,0,1,.49,2.11.23.23,0,0,0,.11.23.11.11,0,0,0,.17-.08A2.68,2.68,0,0,0,328.12,280.11Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.24,282.38a2.28,2.28,0,0,0,0-.45,1.39,1.39,0,0,0-.42-.81.11.11,0,0,0-.16,0,.17.17,0,0,0,0,.19c0,.08.06.12.09.19l0,.08s0,0,0,0v.05a1.64,1.64,0,0,1,.05.32c0,.12,0,.24,0,.36s0,.12,0,.18a.54.54,0,0,0,.16.34.13.13,0,0,0,.13,0C328.26,282.78,328.24,282.54,328.24,282.38Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.67,289.13a1.9,1.9,0,0,0-.73-.83s-.05.07,0,.09a5.22,5.22,0,0,1,.52.85,2.56,2.56,0,0,1,.2.95.28.28,0,0,0,.18.21.13.13,0,0,0,.17-.12A2.89,2.89,0,0,0,326.67,289.13Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.39,290.25a.58.58,0,0,0-.05-.14,1.89,1.89,0,0,0-.11-.25,2.51,2.51,0,0,0-.27-.37s-.11-.07-.15,0a.19.19,0,0,0,0,.2l.11.16.05.09v0s0,0,0,0l0,0a1.46,1.46,0,0,1,.07.19v0h0l0,0a.29.29,0,0,0,0,.09.24.24,0,0,0,.09.11l.06,0s0,0,.05,0h0l0,0a.1.1,0,0,0,0-.07A.29.29,0,0,0,326.39,290.25Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.63,285.84a2.69,2.69,0,0,0-.83-1,.08.08,0,0,0-.14,0,.2.2,0,0,0,0,.2,5.64,5.64,0,0,1,.67.93,5.34,5.34,0,0,1,.38,1.08c0,.12.21.17.21,0A2.71,2.71,0,0,0,330.63,285.84Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.31,287a1.9,1.9,0,0,0-.35-.49s-.12-.07-.16,0a.2.2,0,0,0,0,.21,1.14,1.14,0,0,1,.23.38,1.55,1.55,0,0,1,.07.23s0,0,0,0,0,0,0,.06l0,.14a.5.5,0,0,0,0,.13c0,.06.09.16.17.12l.05,0a.08.08,0,0,0,0-.05.09.09,0,0,0,0-.05.76.76,0,0,0,0-.15A1.77,1.77,0,0,0,330.31,287Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.06,292.46a1.57,1.57,0,0,0-.06-.28,1.88,1.88,0,0,0-.26-.58,1.54,1.54,0,0,0-.8-.69c-.1,0-.07.15,0,.19a2.25,2.25,0,0,1,.64.7,2,2,0,0,1,.16.43l0,.19a.49.49,0,0,1,0,.12.58.58,0,0,0,.1.21s.07.06.11,0,.11-.1.11-.19S330.06,292.51,330.06,292.46Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57,291.87l0-.24a2.83,2.83,0,0,0-.13-.5,2.1,2.1,0,0,0-.24-.41.77.77,0,0,0-.37-.32c-.15,0-.13.18-.07.25s.18.19.23.27a1,1,0,0,1,.14.28,3.45,3.45,0,0,1,.12.43,3.25,3.25,0,0,0,.1.47c.05.12.22.18.26,0A.76.76,0,0,0,336.57,291.87Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.06,272.06a9.52,9.52,0,0,0,1.26,2.16l2.23-2.44L331,273.14l0-1.48s2.44-2,3-3.58A15.91,15.91,0,0,1,329.06,272.06Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.1,282.72a23.91,23.91,0,0,0,2.21-1.37,6.59,6.59,0,0,1,1.18-.61,11.6,11.6,0,0,1,1.25-.44,12.19,12.19,0,0,1-1.11.71,11.19,11.19,0,0,0-1.11.66A6,6,0,0,1,328.1,282.72Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.79,291c.79-.5,1.53-1.06,2.27-1.63s1.47-1.14,2.19-1.72,1.27-1.34,2-2a8.42,8.42,0,0,1,2.42-1.45,11.45,11.45,0,0,0-2.21,1.67c-.66.65-1.21,1.39-1.95,2s-1.48,1.14-2.26,1.67A14.35,14.35,0,0,1,325.79,291Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.93,292.79a7.59,7.59,0,0,0,.84-.77c.27-.26.55-.52.84-.77.59-.5,1.19-.95,1.73-1.47a13.07,13.07,0,0,0,1.52-1.64l.65-.93a3.16,3.16,0,0,1,.8-.83,3.5,3.5,0,0,0-.64.93c-.18.33-.36.67-.56,1a9.76,9.76,0,0,1-1.51,1.76,18.59,18.59,0,0,1-1.8,1.41A15.28,15.28,0,0,1,329.93,292.79Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.77,288.52l-.13,1.1-1.25.38A14.24,14.24,0,0,0,334.77,288.52Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.16,266a32,32,0,0,1-3,2.54c-.52.4-1.06.78-1.58,1.18a2.62,2.62,0,0,0-1.12,1.5,1.09,1.09,0,0,0,.33.82,4.44,4.44,0,0,0,.75.61,2.68,2.68,0,0,0,1.8.47,11.07,11.07,0,0,0,3.68-1.21l.13-.06.06.13a9,9,0,0,0,1.24,2.12l.08.09-.07.09-1.08,1.36h0a19.4,19.4,0,0,1-2.31,2,23.11,23.11,0,0,1-2.64,1.59c-.91.47-1.83.92-2.76,1.34a7.29,7.29,0,0,0-2.48,1.61,1.75,1.75,0,0,0-.44,1.27c0,.48.11,1,.51,1a6.21,6.21,0,0,0,1.44-.13,12.61,12.61,0,0,0,1.49-.28c2-.48,3.92-1.06,5.87-1.65l.75-.23-.5.6a19.22,19.22,0,0,1-1.78,1.95c-.68.56-1.3,1.13-2,1.71s-1.31,1.14-2,1.69a10.29,10.29,0,0,0-1.88,1.71,3.5,3.5,0,0,0-.91,2.2,1.58,1.58,0,0,0,.39,1c.22.25.6.22,1,.06.75-.3,1.46-.85,2.24-1.25s1.55-.8,2.34-1.17l1.1-.52-.87.85-1.29,1.25L324,293a3.34,3.34,0,0,0-.53.66,2.27,2.27,0,0,0-.38,1.56c.13.47.48,1.12.94,1.11a3.13,3.13,0,0,0,1.5-.71c.48-.33,1-.69,1.44-1,1-.74,2.08-1.24,2.95-2l.22.21a9.44,9.44,0,0,0-.75,1,3.12,3.12,0,0,0-.46,1.15.78.78,0,0,0,0,.27,2.49,2.49,0,0,0,.11.29,1.56,1.56,0,0,0,.33.5.83.83,0,0,0,1,.18c.71-.44,1.36-1.07,2.06-1.59a10.56,10.56,0,0,1,1.1-.74,12.28,12.28,0,0,0,1.13-.64c.73-.47,1.39-1.05,2.09-1.56a4.32,4.32,0,0,0,1.12-2.28c.47-1.69,1.18-3.29,1.62-5-.41,1.7-1.1,3.32-1.53,5-.12.42-.23.85-.38,1.26a2.53,2.53,0,0,1-.74,1.11c-.69.53-1.34,1.12-2.07,1.61a12.09,12.09,0,0,1-1.13.68,8.41,8.41,0,0,0-1.06.74,24.47,24.47,0,0,1-2.08,1.62,1.06,1.06,0,0,1-.72.14,1.19,1.19,0,0,1-.64-.35,1.85,1.85,0,0,1-.39-.58,2.19,2.19,0,0,1-.12-.33,1.17,1.17,0,0,1,0-.37,3.41,3.41,0,0,1,.49-1.28,10.31,10.31,0,0,1,.78-1.09l.22.22c-.93.82-2,1.3-3,2-.48.35-.95.72-1.45,1.06-.25.18-.49.34-.76.5a1.9,1.9,0,0,1-.94.29,1.09,1.09,0,0,1-.87-.52,2.35,2.35,0,0,1-.42-.87,2.61,2.61,0,0,1,.41-1.84,4.26,4.26,0,0,1,.59-.74l.64-.62,1.27-1.26.23.33c-.78.37-1.55.77-2.31,1.18s-1.43.92-2.28,1.29a2.05,2.05,0,0,1-.72.15,1.09,1.09,0,0,1-.74-.3,2,2,0,0,1-.53-1.34,4,4,0,0,1,1-2.52,11,11,0,0,1,1.94-1.8c.67-.54,1.31-1.11,2-1.68s1.31-1.16,2-1.7a19.34,19.34,0,0,0,1.74-1.87l.25.37c-2,.58-3.92,1.14-5.91,1.62-.5.11-1,.22-1.53.28a5.75,5.75,0,0,1-1.58.11.91.91,0,0,1-.7-.61,2.63,2.63,0,0,1-.13-.81,2.11,2.11,0,0,1,.55-1.54,7.42,7.42,0,0,1,2.62-1.69c.93-.42,1.84-.86,2.75-1.32a22.06,22.06,0,0,0,2.61-1.54,19.49,19.49,0,0,0,2.28-2h0l1.09-1.35v.18a8.94,8.94,0,0,1-1.27-2.2l.19.08a10.75,10.75,0,0,1-3.79,1.19,2.89,2.89,0,0,1-1.93-.54,4,4,0,0,1-.77-.65,1.26,1.26,0,0,1-.36-1,1.67,1.67,0,0,1,.47-.9,5.21,5.21,0,0,1,.74-.67c.53-.4,1.07-.76,1.6-1.15A33.27,33.27,0,0,0,328.16,266Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.07,210.57c-8.55,1.51-14.52,4.13-18,14.46s-7.88,33.63-8.86,39c-1.7,9.34.73,10.85,7.95,14.11,4.84,2.19,21.06,6.28,33.31,8.19l3.36-15.69c-12.2-4.61-22.57-9-22.57-9l5.16-22.65S289.61,220.79,283.07,210.57Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.29,261.72c-5.55-2-12.37-.05-14.78,1.95,3-5.25,11.52-6.32,15.46-4.95Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.39,129.07c.89,13.85,1.34,18.57,2.19,26.84.7,6.74,2.31,9.54,9.16,19.18,4.9,6.89,13.68,15.57,18.6,21.78,5.23-1,11.75-7.39,15.12-10.79-7.18-11.2-16.7-32.47-16.7-32.47l-.9-33.43s-1.11-23.59-13.47-33.48c-10.76,4-12.76,9.7-14,15.84S160.42,114,161.39,129.07Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.74,196.69h0c5.43-2.18,10.93-7,14.23-10.28h0a55.79,55.79,0,0,0,8.39,9.64c2.75,2.72,9.22,5.86,13.35,9.64s2.64,7.56,2.64,7.56L225.22,210c-2.69-1.49-7.48,4.91-4.84,7.5l5.37,3.38c-3.52,2.44-9.76,3.44-12,1.82s-3.66-1.42-8.14-4.36-5.9-8.33-9.78-13.8C194.57,202.73,194.08,199.64,191.74,196.69Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wheel--inject-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.94,267.61l.77,5.56,58.87,38.08a20.71,20.71,0,0,1,7.19,14.8l4.43,77.43a1.26,1.26,0,0,1-2,1.08h0l-23.49-14.94.2-5.06L309.42,397l-6.21-66.35a20.7,20.7,0,0,0-8.8-14.44l-52.24-36C236.24,276.4,238.74,270.64,243.94,267.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.66,303.77l-2.58-1.63c-6.34-4-12.4-6-17.86-6.33h-.47a24.12,24.12,0,0,0-2.83.06,31,31,0,0,0-21.63,11l-.31.35a7.93,7.93,0,0,0-.53.65l-.35.44c-.15.19-.28.38-.41.56-.25.37-.51.73-.74,1.11l-.26.41c-.11.18-.21.37-.33.56l0,.07A31,31,0,0,0,203,325.61l0,1.24c0,.56-.08,1.14-.1,1.72l-.12,3.05c-1,26.37,16.22,59.16,38.55,73.23l2.57,1.63c6.35,4,12.41,6,17.87,6.33h.15l.22,0c.36,0,.72,0,1.07,0h.35l.92,0,.46,0,.24,0a31,31,0,0,0,22.13-11.7c.23-.28.45-.57.67-.86a.76.76,0,0,1,.08-.11c.25-.34.49-.69.73-1a30.88,30.88,0,0,0,5.2-16l.12-3,.12-3C295.24,350.63,278,317.84,255.66,303.77ZM243,396.7c-18.85-11.88-33.42-39.56-32.55-61.82s16.85-30.68,35.69-18.79,33.42,39.56,32.55,61.82S261.79,408.59,243,396.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.73,308l-2.57-1.63c-11-7-21.25-8-28.88-4.16a5.7,5.7,0,0,0-.59.32l-.15.08c-.23.13-.46.26-.68.4s-.45.28-.67.44a12.44,12.44,0,0,0-1.29.94c-.21.16-.41.34-.61.51A15.62,15.62,0,0,0,211.1,306c-.2.19-.39.4-.57.6s-.37.41-.55.62a7.93,7.93,0,0,0-.53.65l-.35.44c-.15.19-.28.38-.41.56-.25.37-.51.73-.74,1.11l-.26.41c-.11.18-.21.37-.33.56l-.3.56c-.37.69-.73,1.4-1,2.14-.18.4-.35.79-.5,1.2,0,0,0,0,0,.05-.29.73-.55,1.5-.79,2.28-.13.43-.25.85-.37,1.3s-.26,1-.38,1.51l-.15.73c-.09.42-.17.85-.24,1.27s-.16.95-.23,1.45c0,.07,0,.16,0,.24-.05.41-.11.83-.15,1.26,0,.17,0,.34-.05.52,0,.46-.1.94-.12,1.43s-.08,1.14-.1,1.72l-.12,3.05c-1,26.37,16.22,59.16,38.55,73.23l2.57,1.63c6.49,4.08,12.68,6.14,18.24,6.36.36,0,.72,0,1.07,0h.35l.92,0,.46,0,.91-.09.81-.11c.27,0,.52-.08.78-.14.5-.09,1-.21,1.46-.34l.61-.17c.23-.07.46-.13.67-.21s.38-.13.56-.21a10.41,10.41,0,0,0,1.2-.49c.19-.08.39-.17.58-.27l.16-.08a1.19,1.19,0,0,0,.22-.12c.13-.05.25-.12.37-.18,7.52-4.1,12.4-13.12,12.91-26.16l.12-3.05C287.31,354.8,270.05,322,247.73,308ZM243,396.7c-18.85-11.88-33.42-39.56-32.55-61.82s16.85-30.68,35.69-18.79,33.42,39.56,32.55,61.82S261.79,408.59,243,396.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.13,392c-5.77,6.35-15.38,6.91-26,.22-16.75-10.56-29.71-35.17-28.93-55,.34-8.84,3.37-15.23,8.12-18.65-3.36,3.67-5.44,9.26-5.72,16.5-.78,19.79,12.18,44.39,28.93,55C254.78,395.92,263.27,396.25,269.13,392Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.13,392c-5.77,6.35-15.38,6.91-26,.22-16.75-10.56-29.71-35.17-28.93-55,.34-8.84,3.37-15.23,8.12-18.65-3.36,3.67-5.44,9.26-5.72,16.5-.78,19.79,12.18,44.39,28.93,55C254.78,395.92,263.27,396.25,269.13,392Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.09,316.09c-18.84-11.89-34.82-3.47-35.69,18.79s13.7,49.94,32.54,61.82,34.83,3.48,35.7-18.79S264.94,328,246.09,316.09Zm-3,76.13c-16.75-10.56-29.7-35.16-28.93-55s15-27.27,31.73-16.7,29.7,35.16,28.93,54.95S259.87,402.79,243.12,392.22Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.19,365.64c-.06-.36-.12-.71-.19-1.06l-26.74-8.3-.59-.93L267,344.66l-.45-.84-20.31,10.69-.44-1L254,327l-.77-.74-8.08,26.05-.92-1.13L238.63,317c-.34-.11-.68-.22-1-.31l5.54,33.7-1.08-.2-17.37-33-.85.43,17.37,33-.44,1-24.91-23.89c-.12.33-.23.67-.33,1L240.8,353l.41,1.38-26.5-8.22c0,.35.1.7.16,1.05l26.95,8.36.58.93-20.71,10.91c.14.28.28.57.43.85l20.73-10.91.43,1-8.44,27.22.77.75,8.31-26.79.91,1.12,5.78,35.16q.51.17,1,.3l-5.7-34.68,1.08.2,17.74,33.71c.29-.14.56-.3.84-.46l-17.74-33.69.45-1,25.11,24.09.3-1-25.44-24.39-.41-1.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.88,342c-3.23-2-6.19-2.27-8.37-1-.44.26-1,.48-1.56.79-.16.08-.31.18-.47.28l-.08,0,0,0a5,5,0,0,0-.59.44l-.13.12a4.45,4.45,0,0,0-.48.49l-.16.2c-.13.17-.26.34-.38.52a3.21,3.21,0,0,0-.19.31c-.1.17-.19.34-.28.52s-.13.29-.19.43-.15.34-.21.53-.11.37-.17.56-.1.33-.14.5-.09.5-.13.76-.06.28-.08.42c-.05.42-.09.85-.11,1.29-.29,7.42,4.57,16.65,10.86,20.62.39.24.78.46,1.16.66.23.12.46.21.68.3l.47.21.46.15.66.21.25.05c.28.06.56.12.83.15h.06a6,6,0,0,0,3.83-.74c.57-.3,1.08-.53,1.74-.89,2.09-1.15,3.45-3.68,3.59-7.31C258,355.21,253.16,346,246.88,342Zm-4.2,22.23c-1.93-1.64-4.54-6.45-5.54-9.12a21.27,21.27,0,0,0,2,1.32c3,1.68,3-.44,4.15,1.08s.8,5.12-.24,6.94A1.54,1.54,0,0,1,242.68,364.25Zm6.44-13.56a2.89,2.89,0,0,0-.5.21l-1.83.94a2.25,2.25,0,0,0-.92.85c-1.44-1.58-3-6.53-2.76-8.81,2.57,1,6.76,4.78,7.38,6.2,0,.13.08.24.11.34A7.35,7.35,0,0,0,249.12,350.69Zm-8.77-1.88c.84,3.55,2.29,4.15,2.34,5.3-2.27-.46-5.91-2.83-6.07-5.05a8.87,8.87,0,0,1,2.24-5.82C239.81,343.7,239.66,345.9,240.35,348.81Zm5.86,18.7c-1.17-1.15.22-2.18.93-4.45a6.25,6.25,0,0,0,.1-3.33c2.3,2,5.69,7,4.71,8.47l-.12.15C249.81,368.79,247,368.33,246.21,367.51Zm6-7.42c-2.4-3.48-3.45-2.36-4-4.19a2.32,2.32,0,0,1,.92-2.39,3,3,0,0,1,3.62,1.38c1.14,2.24,1.67,6.26,1.64,8.75C253.81,362.71,253.1,361.4,252.19,360.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.88,342c-3.23-2-6.19-2.27-8.37-1-.44.26-1,.48-1.56.79-.16.08-.31.18-.47.28l-.08,0,0,0a5,5,0,0,0-.59.44l-.13.12a4.45,4.45,0,0,0-.48.49l-.16.2c-.13.17-.26.34-.38.52a3.21,3.21,0,0,0-.19.31c-.1.17-.19.34-.28.52s-.13.29-.19.43-.15.34-.21.53-.11.37-.17.56-.1.33-.14.5-.09.5-.13.76-.06.28-.08.42c-.05.42-.09.85-.11,1.29-.29,7.42,4.57,16.65,10.86,20.62.39.24.78.46,1.16.66.23.12.46.21.68.3l.47.21.46.15.66.21.25.05c.28.06.56.12.83.15h.06a6,6,0,0,0,3.83-.74c.57-.3,1.08-.53,1.74-.89,2.09-1.15,3.45-3.68,3.59-7.31C258,355.21,253.16,346,246.88,342Zm-4.2,22.23c-1.93-1.64-4.54-6.45-5.54-9.12a21.27,21.27,0,0,0,2,1.32c3,1.68,3-.44,4.15,1.08s.8,5.12-.24,6.94A1.54,1.54,0,0,1,242.68,364.25Zm6.44-13.56a2.89,2.89,0,0,0-.5.21l-1.83.94a2.25,2.25,0,0,0-.92.85c-1.44-1.58-3-6.53-2.76-8.81,2.57,1,6.76,4.78,7.38,6.2,0,.13.08.24.11.34A7.35,7.35,0,0,0,249.12,350.69Zm-8.77-1.88c.84,3.55,2.29,4.15,2.34,5.3-2.27-.46-5.91-2.83-6.07-5.05a8.87,8.87,0,0,1,2.24-5.82C239.81,343.7,239.66,345.9,240.35,348.81Zm5.86,18.7c-1.17-1.15.22-2.18.93-4.45a6.25,6.25,0,0,0,.1-3.33c2.3,2,5.69,7,4.71,8.47l-.12.15C249.81,368.79,247,368.33,246.21,367.51Zm6-7.42c-2.4-3.48-3.45-2.36-4-4.19a2.32,2.32,0,0,1,.92-2.39,3,3,0,0,1,3.62,1.38c1.14,2.24,1.67,6.26,1.64,8.75C253.81,362.71,253.1,361.4,252.19,360.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,343c-6.28-4-11.61-1.15-11.9,6.26s4.57,16.65,10.86,20.62,11.6,1.15,11.89-6.27S251.33,346.92,245,343Zm-2.91.68c2.3.12,7.65,4.82,8.36,6.44s-1.3,1-3.18,1.55c-2.39.74-1.37,3.07-2.73,2.44C242.59,353.15,239.84,343.51,242.13,343.64Zm-3.45-.49c1.17.24.94,2.56,1.67,5.66.93,3.93,2.61,4.24,2.31,5.68-.43,2.12-7.63-1.35-7.86-4.49S237.5,342.89,238.68,343.15Zm2.18,22c-2.44-2.06-6-9.21-6-10.68s1.89.62,4.21,1.95c3,1.68,3-.44,4.15,1.08C245,359.75,243.3,367.25,240.86,365.18Zm11.09,3c-1.28,1.87-6.4,1.41-7.57.25s.23-2.18.94-4.45c.9-2.88-.77-4.52.26-5C247.07,358.24,253.23,366.34,252,368.2ZM250.37,361c-2.39-3.47-3.44-2.35-4-4.18-.81-2.67,4.69-5.17,6.35-1.95s2,10.09,1.28,10.84S252.27,363.75,250.37,361Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.36,360.51c1.92,1.21,3.55.35,3.64-1.92a7.87,7.87,0,0,0-3.32-6.3c-1.92-1.22-3.55-.36-3.64,1.91A7.9,7.9,0,0,0,244.36,360.51Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lightnings--inject-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bolts--inject-51"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "361.36 258.81 372.35 251.93 365.4 246.76 388.33 234.06 377.58 228.8 402.17 213.48 387.91 227.89 400.65 233.22 373.68 247.18 381.01 253.57 361.36 258.81",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.52 244.18 361.46 236.57 357.22 233.84 363.21 225.68 356.81 223.97 358.31 214.02 354.63 224.9 359.16 226.5 352.65 234.72 357.63 237.79 354.52 244.18",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.65 270.13 375.38 280.1 380.03 272.14 392.73 277.96 397.11 268.21 416.39 271.75 393.74 262.77 388.04 271.86 377.5 267.09 373.75 274.66 360.65 270.13",
    style: {
      fill: "#845EC2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.93,47.79a29.05,29.05,0,0,0-21.17,3.11L279,52.72a29.12,29.12,0,0,0,30.55,49.36l2.88-1.69a29.11,29.11,0,0,0-9.46-52.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.55,45.39a31.67,31.67,0,0,0-36.41,18.45l-9.73,1.34a1.84,1.84,0,0,0-.79,3.33l8.09,5.57a31.61,31.61,0,1,0,38.84-28.69Zm21.06,37.49a29.07,29.07,0,0,1-12.26,17.54l-2.88,1.68A29.12,29.12,0,0,1,279,52.69l2.8-1.82a29.12,29.12,0,0,1,42.81,32Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "302.05 81.95 302.05 93.55 290.45 93.55 290.45 81.95 278.86 81.95 278.86 70.36 290.45 70.36 290.45 58.76 302.05 58.76 302.05 70.36 313.65 70.36 313.65 81.95 302.05 81.95",
    style: {
      fill: "#845EC2"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatients1);
export default __webpack_public_path__ + "static/media/Patients1.53869a3cf01228c98912d12cbbf27cf6.svg";
export { ForwardRef as ReactComponent };